const fromdata = [{
		inputdata: "",
		title: "产品代码",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		disabled: false,
		lablewith: "90px",
		btx: true,
		event: 'prdCodeBlur'
	},
	{
		inputdata: "",
		title: "产品名称",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		lablewith: "90px",
		btx: true,
		disabled: true
	},
	{
		inputdata: "",
		title: "主计量单位",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		lablewith: "90px",
		btx: true,
		disabled: true
	},
	{
		inputdata: "",
		title: "辅计量单位",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "select",
		width: "220px",
		btx: true,
		lablewith: "90px",
		options: [],
	},
	{
		inputdata: "",
		title: "转换率",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		lablewith: "90px",
		btx: true,
	}
];
export default fromdata;